const embed = {
	open: "Open voxtox",
	listen: "Listen on voxtox",
	join: "Join our community on voxtox.fm and create your own!",
	joinSub: "Spoken words, music, podcasts, radio and much more...:)",
	joinSubAlt: "in one audio app for FREE forever!",
	down: "Download the app",
};
export default embed;
